/**
 * Premium-level design intelligence — how the target tier shifts cues and the
 * recommended design languages. Keyed by level slug. Additive, pure data.
 */

export const PREMIUM_LEVEL_KNOWLEDGE = Object.freeze({
  budget: { asOf: '2026', confidence: 0.62, brandPositioning: ['accessible', 'value-driven'], recommendedGenomes: ['bold', 'playful'] },
  mid: { asOf: '2026', confidence: 0.62, brandPositioning: ['reliable', 'modern'], recommendedGenomes: ['modern', 'corporate'] },
  premium: { asOf: '2026', confidence: 0.68, brandPositioning: ['premium', 'refined'], premiumCues: ['refined-type', 'considered-color', 'subtle-depth'], recommendedGenomes: ['minimal', 'editorial', 'modern'] },
  luxury: { asOf: '2026', confidence: 0.72, brandPositioning: ['exclusive', 'luxurious'], premiumCues: ['restraint', 'generous-whitespace', 'crafted-detail', 'confident-scale'], thingsToAvoid: ['clutter', 'busy-background', 'rainbow-palette'], recommendedGenomes: ['luxury', 'luxury-fashion', 'minimal'] },
});
